/* global attachEvent,clickHandler */
// **********************************************************
// Scroll To Next Section
// *************************************************************

attachEvent('.scroll-down', 'click', (ev) => {
  const parentSection = ev.target.closest('.sc-banner');
  clickHandler(parentSection.nextElementSibling.offsetTop);
});
